import { styled } from '@mui/material/styles'
import { DataGridPremium } from '@mui/x-data-grid-premium'

export const Table = styled(DataGridPremium)(({ theme }) => ({
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    borderRadius: '0px',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
  '& .MuiDataGrid-columnHeader--pinnedLeft': {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: theme.palette.common.white,
  },
}))
